import type {Conversation, InteractionID, Message} from "@khan/guide-types";

/**
 * Returns the last outgoing message in the provided conversation with a
 * matching interaction ID.
 */
export const getLastOutgoingMessageById = (
    conversation: Conversation,
    interactionId: InteractionID,
): Message | null => {
    return (
        conversation.findLast(
            (m) => m.type === "outgoing" && m.interactionId === interactionId,
        ) ?? null
    );
};
